




















import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import PagContainer from '@/components/pagContainer.vue'
import { highlightList } from '@/utils/config'

@Component({
  components: {
    PagContainer,
  },
})
export default class Stage extends Vue {
  @State('currPoint') currPoint
  @State('pagIns') pagIns
  @Mutation('setPagIns') setPagIns
  pagList = highlightList
  delayPoint = 4
  @Watch('currPoint')
  watchCurrPointChange(newVal) {
    let currInx = highlightList.findIndex((item) => item.station === newVal)
    if (currInx !== -1) {
      let ref = this.$refs[`highLight${currInx}`]
      let pagRef: any = ref && ref[0]
      pagRef && pagRef.onPlay()
    }
  }

  handleReady() {
    // let currInx = highlightList.findIndex(
    //   (item) => item.station === this.currPoint
    // )
    // if (currInx !== -1) {
    //   let pagRef: any = this.$refs[`highLight${currInx}`][0]
    //   pagRef && pagRef.onPlay()
    // }
  }
}
